export default __webpack_public_path__ + "static/media/asmt-step3.05fe7dc8.gif";